module.exports = __webpack_public_path__ + "img/ch09_06_过膝袜.7a583c78.jpg";